const COMPLETED_STORE_ACTION_ROLES: ReadonlyArray<string> = [
  'FSC-SM',
  'SM',
  'FSC-SSM',
  'SSM',
  'CAM',
  'FSC-DMT',
  'DMT',
  'FSC-DM',
  'DM',
  'FSC-RDT',
  'RDT',
  'FSC-RD',
  'RD',
  'GT',
  'GTE',
  'GDE',
  'GD',
  'DR',
  'ABG',
  'AOP',
  'ASI',
  'CO',
  'GAO',
  'DAO',
];

export const canManageCompletedStoreActions = (role: string): boolean =>
  COMPLETED_STORE_ACTION_ROLES.includes(role.trim());
